import { MascotBubble } from '@tankef/ui';

import type { StepType } from '@reactour/tour';

export const SAVINGS_BOX_TOUR_ID = 'savings-box';

export const savingsBoxSteps: StepType[] = [
  {
    selector: '[data-tour="savings-kpi"]',
    position: 'bottom',
    content: (
      <MascotBubble emotion="happy" size="sm" direction="right" showPointer={false}>
        Aquí ves el <strong>resumen de tus cajas de ahorro</strong>: saldo total, intereses ganados
        y próximos vencimientos.
      </MascotBubble>
    ),
  },
  {
    selector: '[data-tour="savings-new-btn"]',
    position: 'bottom',
    content: (
      <MascotBubble emotion="celebrating" size="sm" direction="left" showPointer={false}>
        Toca aquí para <strong>abrir una nueva caja de ahorro</strong>. Elige el plazo y la tasa que
        más te convenga.
      </MascotBubble>
    ),
  },
  {
    selector: '[data-tour="savings-table"]',
    position: 'top',
    content: (
      <MascotBubble emotion="neutral" size="sm" direction="right" showPointer={false}>
        Tus <strong>cajas activas</strong>. Toca una para ver la tabla de rendimientos, hacer abonos
        o descargar tu estado de cuenta.
      </MascotBubble>
    ),
  },
];
